import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");

// Check if the app was server-rendered
const isServerRendered = rootElement.hasChildNodes();

if (isServerRendered) {
    // Use hydrateRoot for SSR
    hydrateRoot(
        rootElement,
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
} else {
    // Use createRoot for CSR
    const root = createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
